"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = require("../Box");

var _Spinner = require("../Spinner");

var _Typography = require("../Typography");

var _tokens = require("./tokens");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A button with various size and color settings */
var Button = function Button(_ref) {
  var children = _ref.children,
      loading = _ref.loading,
      color = _ref.color,
      size = _ref.size,
      weight = _ref.weight,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["children", "loading", "color", "size", "weight", "onClick"]);

  var handleClick = function handleClick(event) {
    if (!loading && onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    onClick: handleClick,
    size: size,
    loading: loading
  }, rest), loading && /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
    size: size
  }), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    pt: "1px",
    weight: weight || "medium",
    size: _tokens.BUTTON_TEXT_SIZES[size]
  }, children));
};

exports.Button = Button;
Button.displayName = "Button";
Button.defaultProps = {
  size: "medium",
  variant: "primaryBlack",
  border: 1,
  borderRadius: 3
};

var Container = _styledComponents.default.button.withConfig({
  displayName: "Button__Container",
  componentId: "sc-1bhxy1c-0"
})(["display:inline-block;cursor:pointer;position:relative;white-space:nowrap;text-decoration:none;align-items:center;", ";", ";", ";", " &:disabled{background-color:", ";border-color:", ";color:", ";pointer-events:none;}"], _Box.boxMixin, (0, _styledSystem.variant)({
  variants: _tokens.BUTTON_VARIANTS
}), function (props) {
  return (0, _styledSystem.variant)({
    prop: "size",
    variants: _tokens.BUTTON_SIZES[props.inline ? "inline" : "block"]
  })(props);
}, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? (0, _styledComponents.css)(["transition:none;background-color:transparent !important;color:transparent !important;border-color:transparent !important;cursor:auto;"]) : (0, _styledComponents.css)(["transition:color 0.25s ease,border-color 0.25s ease,background-color 0.25s ease;"]);
}, (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.white100"));
//# sourceMappingURL=Button.js.map